import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import {
  BiomarkLogo as bioMarkLogoVertical,
  BiomarkText as bioMarkText,
} from '../../assets/Images';
import { pageNotFoundStyles } from '../../styles/pageNotFoundStyles';

const NotFoundPage = () => {
  const classes = pageNotFoundStyles();
  const navigate = useNavigate();
  return (
    <Box className={classes.notFoundParent}>
      <Box className={classes.notfoundpagebox}>
        <Box className={classes.imgBox}>
          <img className={classes.logo} src={bioMarkLogoVertical} alt="" />
          <img src={bioMarkText} alt="" />
          <Box className={classes.imgBoxText}>Lab Dispatch App</Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '1rem',
          }}
        >
          {' '}
          <Typography className={classes.notFoundHeading}>404</Typography>
          <Typography className={classes.notFoundSubHeading}>
            Oops! Page Not Found
          </Typography>
          <Typography className={classes.heading2}>
            Sorry the Page you are looking for does not exist
          </Typography>
        </Box>
        <Box>
          <Button className={classes.backHomeBtn} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFoundPage;
